/*
 * Copyright (C) Zoomdata, Inc. 2012-2022. All rights reserved.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { EmbeddedComponent } from './EmbeddedComponent';
import { ComponentTypes, SourceEditorEventNames } from './types';
export const DefaultIds = {
    tabs: ['create', 'fields', 'caching', 'settings'],
};
export var SourceEditorTabs;
(function (SourceEditorTabs) {
    SourceEditorTabs["CREATE"] = "create";
    SourceEditorTabs["FIELDS"] = "fields";
    SourceEditorTabs["CACHING"] = "caching";
    SourceEditorTabs["SETTINGS"] = "settings";
})(SourceEditorTabs || (SourceEditorTabs = {}));
export class EmbeddedSourceEditor extends EmbeddedComponent {
    notificationSettings;
    sourceId;
    activeTab;
    tabs;
    header;
    breadcrumbs;
    interactivityOverrides;
    componentType = ComponentTypes.SOURCE_EDITOR;
    /**
     *
     * @param theme - The theme for the embedded source editor. Valid values are `composer`, `modern`, or `dark`.
     * The initial default theme, `composer`, is the same as the `modern` theme.
     * However, if you add your own themes to the application, more options are available in this list and you may have introduced a different default.
     * @param renderer
     * @param sourceId - Source ID.
     * @param activeTab - Active Tab.
     * @param tabs - Defines configuration of tabs.
     * @param header - Defines configuration of header.
     * @param breadcrumbs - Defines configuration of breadcrumbs.
     * @param interactivityOverrides - Defines interactivity settings for an embedded source editor.
     * @param notificationSettings - Specifies settings for notifications.
     */
    constructor(theme, renderer, sourceId, activeTab, tabs, header, breadcrumbs, interactivityOverrides, notificationSettings) {
        super(theme, null, renderer, notificationSettings);
        this.notificationSettings = notificationSettings;
        const { create = {}, fields = {}, caching = {}, settings = {} } = tabs || {};
        const isValidTab = Object.values(SourceEditorTabs).includes(activeTab);
        if (!isValidTab) {
            console.warn(`"${activeTab}" tab does not exist`);
        }
        this.sourceId = sourceId;
        this.activeTab = isValidTab ? activeTab : SourceEditorTabs.CREATE;
        this.tabs = {
            create: {
                visible: true,
                connections: create.connections || {},
                ...create,
            },
            fields: {
                visible: true,
                ...fields,
            },
            caching: {
                visible: true,
                ...caching,
            },
            settings: {
                visible: true,
                ...settings,
            },
        };
        this.header = {
            visible: true,
            showTitle: true,
            ...(header || {}),
        };
        this.breadcrumbs = breadcrumbs ?? {};
        this.interactivityOverrides = interactivityOverrides ?? {};
    }
    getApplicationParams() {
        const base = super.getApplicationParams();
        return {
            ...base,
            componentProps: {
                sourceId: this.sourceId,
                activeTab: this.activeTab,
                tabs: this.tabs,
                header: this.header,
                breadcrumbs: this.breadcrumbs,
                interactivitySettings: this.interactivityOverrides,
            },
        };
    }
    render(element, attributes) {
        super.render(element, attributes);
        this.htmlElement.addEventListener(SourceEditorEventNames.READY, this.removeLoader);
    }
    destroy() {
        this.htmlElement.removeEventListener(SourceEditorEventNames.READY, this.removeLoader);
    }
    addEventListener(eventName, callback) {
        this.htmlElement.addEventListener(eventName, callback);
    }
    removeEventListener(eventName, callback) {
        this.htmlElement.removeEventListener(eventName, callback);
    }
}
//# sourceMappingURL=EmbeddedSourceEditor.js.map